import { NoSsr } from '@cian/react-utils';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { useNativeSharing } from './hooks/useNativeSharing';
import { selectProjectTitle } from '../../selectors';
import { ShareButton } from '../../components/ShareButton';

export function ShareButtonContainer() {
  const title = useSelector(selectProjectTitle);
  const { isEnabled, share } = useNativeSharing(title);

  if (!isEnabled) {
    return null;
  }

  return (
    <NoSsr>
      <ShareButton onClick={share} />
    </NoSsr>
  );
}
